module.exports = __webpack_public_path__ + "static/media/YM53_1.db3a23e0.jpg";